import { appShellTheme } from './app-shell'
import { bannerTheme } from './banner'
import { commandTheme } from './command'
import { emptyStateTheme } from './empty-state'
import { formTheme } from './form'
import { formLayoutTheme } from './form-layout'
import { formLegendTheme } from './form-legend'
import { hotkeysTheme } from './hotkeys'
import { loadingOverlayTheme } from './loading-overlay'
import { navGroupTheme } from './nav-group'
import { navItemTheme } from './nav-item'
import { nprogressTheme } from './nprogress'
import { personaTheme } from './persona'
import { propertyTheme } from './property'
import { searchInputTheme } from './search-input'
import { sidebarTheme } from './sidebar'
import { selectTheme } from './select'
import { structuredListTheme } from './structured-list'
import { timelineTheme } from './timeline'
import { iconBadgeTheme } from './icon-badge'
import { navbarTheme } from './navbar'

export { appShellTheme as SuiAppShell } from './app-shell'
export { bannerTheme as SuiBanner } from './banner'
export { commandTheme as SuiCommand } from './command'
export { emptyStateTheme as SuiEmptyState } from './empty-state'
export { formLayoutTheme as SuiFormLayout } from './form-layout'
export { formTheme as Form } from './form'
export { formLegendTheme as SuiFormLegend } from './form-legend'
export { hotkeysTheme as SuiHotkeys } from './hotkeys'
export { loadingOverlayTheme as SuiLoadingOverlay } from './loading-overlay'
export { navGroupTheme as SuiNavGroup } from './nav-group'
export { navItemTheme as SuiNavItem } from './nav-item'
export { personaTheme as SuiPersona } from './persona'
export { propertyTheme as SuiProperty } from './property'
export { nprogressTheme as SuiNProgress } from './nprogress'
export { searchInputTheme as SuiSearchInput } from './search-input'
export { selectTheme as SuiSelect } from './select'
export { sidebarTheme as SuiSidebar } from './sidebar'
export { structuredListTheme as SuiStructuredList } from './structured-list'
export { timelineTheme as SuiTimeline } from './timeline'
export { iconBadgeTheme as SuiIconBadge } from './icon-badge'
export { navbarTheme as SuiNavbarTheme } from './navbar'

export const components = {
  Form: formTheme,
  SuiAppShell: appShellTheme,
  SuiBanner: bannerTheme,
  SuiCommand: commandTheme,
  SuiEmptyState: emptyStateTheme,
  SuiFormLayout: formLayoutTheme,
  SuiFormLegend: formLegendTheme,
  SuiHotkeys: hotkeysTheme,
  SuiStructuredList: structuredListTheme,
  SuiLoadingOverlay: loadingOverlayTheme,
  SuiNavGroup: navGroupTheme,
  SuiNavItem: navItemTheme,
  SuiPersona: personaTheme,
  SuiProperty: propertyTheme,
  SuiNProgress: nprogressTheme,
  SuiSearchInput: searchInputTheme,
  SuiSelect: selectTheme,
  SuiSidebar: sidebarTheme,
  SuiTimeline: timelineTheme,
  SuiIconBadge: iconBadgeTheme,
  SuiNavbar: navbarTheme,
}
